module.exports = __webpack_public_path__ + "static/img/card-templates_on.5b28e5ec.png";